import { Input as InputAntd } from 'antd'
import { OTPProps } from 'antd/es/input/OTP'

interface InputOTPProps extends OTPProps {}

export const InputOTP = ({ ...props }: InputOTPProps) => {
  return <InputAntd.OTP {...props} />
}
